import { createRouter, createWebHistory } from 'vue-router'

const routes = [ 
    {
        path: '/',
        component: () => import('../views/index1'),
    }, 
    {
        path: '/index1',
        component: () => import('../views/index1'),
    }, 
    {
        path: '/index2',
        component: () => import('../views/index2'),
    }, 
    {
        path: '/index3',
        component: () => import('../views/index3'),
    }, 
    {
        path: '/index4',
        component: () => import('../views/index4'),
    }, 
    {
        path: '/index5',
        component: () => import('../views/index5'),
    }, 
    {
        path: '/index6',
        component: () => import('../views/index6'),
    }, 
    {
        path: '/index7',
        component: () => import('../views/index7'),
    }, 
    {
        path: '/index8',
        component: () => import('../views/index8'),
    }, 
    {
        path: '/index9',
        component: () => import('../views/index9'),
    }, 
    {
        path: '/index10',
        component: () => import('../views/index10'),
    }, 
    {
        path: '/index11',
        component: () => import('../views/index11'),
    }, 
    {
        path: '/index12',
        component: () => import('../views/index12'),
    }, 
    {
        path: '/index13',
        component: () => import('../views/index13'),
    }, 
    {
        path: '/index14',
        component: () => import('../views/index14'),
    }, 
    {
        path: '/index15',
        component: () => import('../views/index15'),
    }, 
    {
        path: '/index16',
        component: () => import('../views/index16'),
    }, 
    {
        path: '/index17',
        component: () => import('../views/index17'),
    }, 
    {
        path: '/index18',
        component: () => import('../views/index18'),
    }, 
    {
        path: '/blog-sidebar',
        component: () => import('../views/blog-sidebar'),
    }, 
    {
        path: '/blog-single',
        component: () => import('../views/blog-single'),
    }, 
    
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router;